import Vue from "vue";
import {mapMutations, mapState} from "vuex";
import toast from './toast'

Vue.mixin({
    mixins: [toast],
    data() {
        return {

        };
    },
    computed: {
        ...mapState(["mapLoading", "adcode", "map_name", "level", "mapHistoryData"]),
    },
    created() {},
    methods: {
        ...mapMutations(["setMapHistoryData", "setValue"]),
    },

});